"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const lodash_1 = require("lodash");
const AccountSpecifications_1 = __importDefault(require("../../sample/AccountSpecifications"));
const CTAMessage_1 = __importDefault(require("../../sample/CTAMessage"));
const core_1 = require("@emotion/core");
const hookUrlStyle = core_1.css `
  font-family: monospace;
`;
const SkippedTriggerTestMessage = (props) => {
    const message = props.isWebhook && props.webhookUrl ? (core_1.jsx(react_1.Fragment, null,
        "If you change your mind, send a new request to this webhook URL:",
        ' ',
        core_1.jsx("span", { css: hookUrlStyle }, props.webhookUrl),
        " and test your trigger again.")) : props.isWebhook && !props.webhookUrl ? (core_1.jsx(react_1.Fragment, null, "If you change your mind, send a new request to your webhook and test your trigger again.")) : (core_1.jsx(react_1.Fragment, null,
        "If you change your mind, create a new ",
        lodash_1.lowerCase(props.noun),
        " in your",
        ' ',
        core_1.jsx(AccountSpecifications_1.default, { authTitle: props.authTitle, hasServiceAuthType: props.hasServiceAuthType, serviceKey: props.serviceKey, serviceName: props.serviceName }),
        ' ',
        "and test your trigger again."));
    return (core_1.jsx(CTAMessage_1.default, { emojiLabel: "next track", emojiSymbol: '⏭️', headerText: "You skipped the trigger test", isWaiting: props.isTesting, message: message, onPrimaryButtonClick: props.onDone, onSecondaryButtonClick: props.onTest, primaryButtonText: "Continue", secondaryButtonText: "Test trigger", waitingText: "Testing" }));
};
exports.default = SkippedTriggerTestMessage;
